const adminNamespace = '/admin';

const apiTokenListViewRelative = '/tokens';
const licenseViewRelative = '/license';
const rulesViewRelative = '/rules';
const emailFetchCredentialsViewRelative = '/email-fetch/credentials';
const emailFetchAccountsViewRelative = '/email-fetch/accounts';
const emailFetchTasksViewRelative = '/email-fetch/tasks';

const audioAnonymizationTasksViewRelative = '/audio-anonymization-tasks/tasks';

const transcriptionsTasksViewRelative = '/transcription-tasks/tasks';
const transcriptionsTasksNotSentViewRelative = '/transcription-tasks/not_sent';
const transcriptionsTasksInTranscriptionViewRelative = '/transcription-tasks/in_transcription';

const searchIndexViewRelative = '/search_index/:index_type';
const searchIndexViewRelativeDefault = '/search_index/full';

const qualityAssuranceViewRelative = '/quality_assurance/:event_type/:date_type';
const qualityAssuranceViewRelativeDefault = '/quality_assurance/call/datetime';
const celeryQueueRelative = '/celery_queue';

const apiTokenListViewRoute = `${adminNamespace}${apiTokenListViewRelative}`;
const licenseViewRoute = `${adminNamespace}${licenseViewRelative}`;
const rulesViewRoute = `${adminNamespace}${rulesViewRelative}`;
const emailFetchCredentialsViewRoute = `${adminNamespace}${emailFetchCredentialsViewRelative}`;
const emailFetchAccountsViewRoute = `${adminNamespace}${emailFetchAccountsViewRelative}`;
const emailFetchTasksViewRoute = `${adminNamespace}${emailFetchTasksViewRelative}`;
const audioAnonymizationTasksViewRoute = `${adminNamespace}${audioAnonymizationTasksViewRelative}`;
const transcriptionsTasksViewRoute = `${adminNamespace}${transcriptionsTasksViewRelative}`;
const transcriptionsTasksNotSentViewRoute = `${adminNamespace}${transcriptionsTasksNotSentViewRelative}`;
const transcriptionsTasksInTranscriptionViewRoute = `${adminNamespace}${transcriptionsTasksInTranscriptionViewRelative}`;
const searchIndexViewRoute = `${adminNamespace}${searchIndexViewRelative}`;
const searchIndexViewRouteDefault = `${adminNamespace}${searchIndexViewRelativeDefault}`;
const qualityAssuranceViewRoute = `${adminNamespace}${qualityAssuranceViewRelative}`;
const qualityAssuranceViewRouteDefault = `${adminNamespace}${qualityAssuranceViewRelativeDefault}`;
const celeryQueueRoute = `${adminNamespace}${celeryQueueRelative}`;

export const adminNamespaces = {
    adminNamespace,
};

export const adminRelativeRoutes = {
    apiTokenListViewRelative,
    apiTokenListViewRoute,
    licenseViewRelative,
    rulesViewRelative,
    emailFetchCredentialsViewRelative,
    emailFetchAccountsViewRelative,
    emailFetchTasksViewRelative,
    audioAnonymizationTasksViewRelative,
    transcriptionsTasksViewRelative,
    transcriptionsTasksNotSentViewRelative,
    transcriptionsTasksInTranscriptionViewRelative,
    searchIndexViewRelative,
    qualityAssuranceViewRelative,
    celeryQueueRelative,
};

export const adminAbsoluteRoutes = {
    licenseViewRoute,
    rulesViewRoute,
    emailFetchCredentialsViewRoute,
    emailFetchAccountsViewRoute,
    emailFetchTasksViewRoute,
    audioAnonymizationTasksViewRoute,
    transcriptionsTasksViewRoute,
    transcriptionsTasksNotSentViewRoute,
    transcriptionsTasksInTranscriptionViewRoute,
    searchIndexViewRoute,
    searchIndexViewRouteDefault,
    qualityAssuranceViewRoute,
    qualityAssuranceViewRouteDefault,
    celeryQueueRoute,
};
